export const MoonIcon = () => (
  <span role="img" aria-label="moon" className="anticon anticon-moon">
    <svg
      viewBox="0 0 24 24"
      focusable="false"
      data-icon="moon"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  </span>
);
